/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseCancelInfoGoodsInfoVo
 */
export interface PurchaseCancelInfoGoodsInfoVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    id?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    code?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    imgUrl?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    color?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    size?: string;
    /**
     * 是否合包商品 0 否 1 是
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    combined?: number;
    /**
     * 采购手续费
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    additionalFee?: number;
    /**
     * 平台采购订单号
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 商品状态
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    status?: number;
    /**
     * 商品状态
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    goodsStatusName?: string;
    /**
     * 商品SKU ID
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    skuId?: number;
    /**
     * 商品SKU编码
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    skuCode?: string;
    /**
     * 商品单价（人民币）
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    unitPrice?: number;
    /**
     * 商品SKU总金额（美元）
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    totalPriceUsd?: number;
    /**
     * 商品SKU总金额（人民币）
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    totalPriceCny?: number;
    /**
     * 商品SKU总金额（韩币）
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    totalPriceKrw?: number;
    /**
     * 中国国内运费
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    chinaDomesticShippingFee?: number;
    /**
     * 商品数量
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    initQuantity?: number;
    /**
     * 构成
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    constructCount?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    name?: string;
    /**
     * 税点
     * @type {number}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    purchaseTax?: number;
    /**
     * 基础商品信息 如果本商品是合包商品，这个字段才有值
     * @type {Array<PurchaseCancelInfoGoodsInfoVo>}
     * @memberof PurchaseCancelInfoGoodsInfoVo
     */
    baseGoodsInfo?: Array<PurchaseCancelInfoGoodsInfoVo>;
}

/**
 * Check if a given object implements the PurchaseCancelInfoGoodsInfoVo interface.
 */
export function instanceOfPurchaseCancelInfoGoodsInfoVo(value: object): value is PurchaseCancelInfoGoodsInfoVo {
    return true;
}

export function PurchaseCancelInfoGoodsInfoVoFromJSON(json: any): PurchaseCancelInfoGoodsInfoVo {
    return PurchaseCancelInfoGoodsInfoVoFromJSONTyped(json, false);
}

export function PurchaseCancelInfoGoodsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCancelInfoGoodsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'additionalFee': json['additionalFee'] == null ? undefined : json['additionalFee'],
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'status': json['status'] == null ? undefined : json['status'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'totalPriceCny': json['totalPriceCny'] == null ? undefined : json['totalPriceCny'],
        'totalPriceKrw': json['totalPriceKrw'] == null ? undefined : json['totalPriceKrw'],
        'chinaDomesticShippingFee': json['chinaDomesticShippingFee'] == null ? undefined : json['chinaDomesticShippingFee'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'name': json['name'] == null ? undefined : json['name'],
        'purchaseTax': json['purchaseTax'] == null ? undefined : json['purchaseTax'],
        'baseGoodsInfo': json['baseGoodsInfo'] == null ? undefined : ((json['baseGoodsInfo'] as Array<any>).map(PurchaseCancelInfoGoodsInfoVoFromJSON)),
    };
}

export function PurchaseCancelInfoGoodsInfoVoToJSON(json: any): PurchaseCancelInfoGoodsInfoVo {
    return PurchaseCancelInfoGoodsInfoVoToJSONTyped(json, false);
}

export function PurchaseCancelInfoGoodsInfoVoToJSONTyped(value?: PurchaseCancelInfoGoodsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'combined': value['combined'],
        'additionalFee': value['additionalFee'],
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'status': value['status'],
        'goodsStatusName': value['goodsStatusName'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'unitPrice': value['unitPrice'],
        'totalPriceUsd': value['totalPriceUsd'],
        'totalPriceCny': value['totalPriceCny'],
        'totalPriceKrw': value['totalPriceKrw'],
        'chinaDomesticShippingFee': value['chinaDomesticShippingFee'],
        'initQuantity': value['initQuantity'],
        'constructCount': value['constructCount'],
        'name': value['name'],
        'purchaseTax': value['purchaseTax'],
        'baseGoodsInfo': value['baseGoodsInfo'] == null ? undefined : ((value['baseGoodsInfo'] as Array<any>).map(PurchaseCancelInfoGoodsInfoVoToJSON)),
    };
}

